import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { UnknownAction } from 'redux';
import { ThunkAction } from '@reduxjs/toolkit';
import { store } from './store';

export type AppRootState = ReturnType<typeof store.getState>;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppRootState,
  unknown,
  UnknownAction
>

type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch<AppDispatch>;

export const useAppSelector: TypedUseSelectorHook<AppRootState> = useSelector;
